export const EUR_EXCHANGE_RATE = 1.95583;
